/**
 * Builds the aggregates payload for POST /api/ai/account-analysis: month-end
 * balance history (walked backwards from the live balance), the projected
 * month-ends when a forecast horizon is on, and summary stats. Only
 * client-computed aggregates — never raw transactions.
 */

const round2 = (n) => Math.round(n * 100) / 100;

export default function buildAccountAnalysisPayload(account, history, forecast) {
  if (!account || !history || !history.points?.length) return null;
  const points = history.points;
  const balances = points.map((p) => p.value);
  const current = balances[balances.length - 1];
  const byValue = [...points].sort((a, b) => a.value - b.value);

  return {
    account: {
      name: account.name,
      type: account.type,
      institution: account.institution || '',
    },
    currency: 'NZD',
    monthlyBalances: points.map((p) => ({ month: p.month, balance: p.value })),
    forecast: (forecast || []).map((p) => ({ month: p.month, balance: p.value })),
    stats: {
      currentBalance: round2(current),
      changeOverWindow: round2(current - history.baseline),
      min: byValue[0] || null,
      max: byValue[byValue.length - 1] || null,
    },
  };
}
